<template>
  <div>
    <el-tabs type="border-card" @tab-click="handleClick">
      <el-tab-pane label="基本信息">
        <div class="line">基本信息</div>
        <div  class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple">
                <ul v-for="item in BasicInfo" :key="item.index">
                  <li class="LRstyle">
                    <span >出差目的</span>
                    <span>{{item.AimName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出差事由</span>
                    <span>{{item.Content}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>成本对象编码</span>
                    <span>{{item.PID}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>成本对象</span>
                    <span>{{item.ProjectName}}</span>
                  </li>
                    <li class="LRstyle">
                      <span >是否长差</span>
                      <span>
                          <el-radio v-model="LongApplyFor"  label="1" disabled>是</el-radio>
                          <el-radio v-model="LongApplyFor"  label="2" disabled>否</el-radio>
                      </span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="line">出差人员<span>（{{UserInfo.length}}）</span></div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple">
                 <ul v-for="item in UserInfo" :key="item.index">
                  <li class="LRstyle">
                    <span >姓名</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>类别</span>
                    <span>{{item.UserType}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>部门</span>
                    <span>{{item.DeptName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>工作基地</span>
                    <span>{{item.WorkPlace}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>电话</span>
                    <span>{{item.Mobile}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="line">城市间交通费<span>（{{TrafficFee.length}}）</span></div>
        <div  class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple">
                 <ul v-for="item in TrafficFee" :key="item.index">
                  <li class="LRstyle">
                    <span >人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>票据类型</span>
                    <span>{{item.TicketType}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出发地</span>
                    <span>{{item.StartCity}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>目的地</span>
                    <span>{{item.EndCity}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>出发时间</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>报销金额</span>
                    <span>{{item.Sum}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="line">住宿费用<span>（{{HotelFee.length}}）</span></div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="HotelFee.length>0">
                <ul v-for="item in HotelFee" :key="item.index">
                  <li class="LRstyle">
                    <span >人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>城市</span>
                    <span>{{item.City}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>酒店名称</span>
                    <span>{{item.HotelName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>入住时间</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>离开时间</span>
                    <span>{{item.EndDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>金额</span>
                    <span>{{item.Sum}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>标准金额</span>
                    <span>{{item.SumStandard}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="line">补助费用<span>（{{Allowance.length}}）</span></div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="Allowance.length>0">
                <ul v-for="item in Allowance" :key="item.index">
                  <li class="LRstyle">
                    <span >人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>开始日期</span>
                    <span>{{item.StartDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>结束日期</span>
                    <span>{{item.EndDate}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>补助天数</span>
                    <span>{{item.TripDays}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>金额（元）</span>
                    <span>{{item.Sum}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="line">其他费用<span>（{{OtherFee.length}}）</span></div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="OtherFee.length>0">
                <ul v-for="item in OtherFee" :key="item.index">
                  <li class="LRstyle">
                    <span >人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>报销类别</span>
                    <span>{{item.CostCodeName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>月份</span>
                    <span>{{item.CostMonthStub}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>备注</span>
                    <span>{{item.Remark}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>核定金额（元）</span>
                    <span>{{item.Sum}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="line">支付信息<span>（{{PaymentInfo.length}}）</span></div>
        <div class="info-box">
          <el-row :gutter="10">
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="grid-content bg-purple" v-if="PaymentInfo.length>0">
                 <ul v-for="item in PaymentInfo" :key="item.index">
                  <li class="LRstyle">
                    <span >人员</span>
                    <span>{{item.UserName}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>收款账号</span>
                    <span>{{item.PayAccount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>合计金额</span>
                    <span>{{item.Amount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>冲抵备用金</span>
                    <span>{{item.ReserveFundsAmount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>冲抵公司卡</span>
                    <span>{{item.CompanyCardAmount}}</span>
                  </li>
                  <li class="LRstyle">
                    <span>应支付金额</span>
                    <span>{{item.PayAmount}}</span>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </div>
        <div class="line">附件信息</div>
        <div class="info-box">
            <el-row :gutter="10">
                <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="grid-content bg-purple" v-if="fileRepertories.length>0">
                        <span v-for="item in fileRepertories" :key="item.index">
                          <img src="" v-lazy="item.url" alt="附件信息" class="fileRepertories">
                        </span>
                    </div>
                    </el-col>
                <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
            </el-row>
        </div>
        <div class="line">历史审批记录</div>
        <div  class="suggest-box info-box">
            <el-row :gutter="10">
                <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="grid-content bg-purple">
                      <el-table :data="AuditHistory" style="width: 100%">
                        <el-table-column prop="UserName" label="操作人">
                        </el-table-column>
                        <el-table-column prop="FinishDate" label="操作时间">
                        </el-table-column>
                        <el-table-column prop="Status" label="状态">
                        </el-table-column>
                        <el-table-column prop="Suggestion" label="备注">
                        </el-table-column>
                      </el-table>
                    </div>
                    </el-col>
                <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
            </el-row>
        </div>
        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
          <span>请填写审批意见！</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>

      <el-tab-pane label="审批意见">
          <el-form ref="form" label-width="80px">
            <el-form-item class="label-suggest" label="填写审批意见">
              <el-input type="textarea" v-model="suggestion"></el-input>
            </el-form-item>
            <el-form-item class="btn-suggest">
              <el-button type="primary" :plain="true" @click="open">通过</el-button>
              <el-button type="primary" :plain="true" @click="openVn">退回</el-button>
            </el-form-item>
          </el-form>
      </el-tab-pane>
    </el-tabs>
     <el-button type="text" @click="open2" class="goback" v-if="tabId !== 'tab-1'">
        <el-button type="info" class="go">通过</el-button>
        <el-button type="info" class="back">退回</el-button>
    </el-button>
  </div>
</template>
<script>
import { getApiURL } from "../config";
export default {
    data() {
        return {
            id: this.$route.query.id,
            List: [],
            BasicInfo: [],
            TrafficFee: [],
            HotelFee: [],
            PaymentInfo: [],
            UserInfo: [],
            OtherFee: [],
            Allowance: [],
            AuditHistory: [],
            fileRepertories: [],
            LongApplyFor: "1",
            suggestion: "",
            tabId: "",
            activeIndex: "1",
            activeIndex2: "1",
            centerDialogVisible: false,
            form: {
                suggest: ""
            },
            message: ""
        };
    },
    methods: {
        //通过审批
        open() {
            let email = localStorage.email;
            let suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            let rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' +
                    email +
                    ',"encrypted": "1","data": {"ComType": "SubmitAudit","FlowID": ' +
                    id +
                    ', "Suggestion": ' +
                    suggest +
                    "}}"
            }).then(res => {
                let Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "提交审批成功",
                position: "top-left"
            });
            setTimeout(() => {
                this.$router.push({ path: "/tripReimbursement" });
                this.activeIndex = "2";
            }, 2000);
        },
        //   退回审批
        openVn() {
            let email = localStorage.email;
            let suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            let rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' +
                    email +
                    ',"encrypted": "1","data": {"ComType": "AuditReturn","FlowID": ' +
                    id +
                    ', "Suggestion": ' +
                    suggest +
                    "}}"
            }).then(res => {
                let Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "驳回审批成功",
                position: "top-left"
            });
            setTimeout(() => {
                this.$router.push({ path: "/tripReimbursement" });
            }, 1000);
        },
        open2() {
            this.$confirm("请填写审批意见, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            })
                .then(() => {
                    document.getElementById("tab-1").click();
                })
                .catch(() => {});
        },
        handleClick(tab, event) {
            let $this = this;
            $this.tabId = event.target.id;
        },
        getDetail() {
            let email = localStorage.email;
            let $this = this;
            let id = '"' + this.id + '"';
            let rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' +
                    email +
                    ',"encrypted": "1","data": {"ComType": "GetDetailsOfFlow","FlowID": ' +
                    id +
                    ', "FlowTypeID": 1}}'
            })
                .then(function(res) {
                    let Data = res.data.data;
                    let obj = {},
                        list = new Array(obj);
                    obj["AimName"] = Data.BasicInfo.AimName;
                    obj["Content"] = Data.BasicInfo.Content;
                    obj["PID"] = Data.BasicInfo.PID;
                    obj["ProjectName"] = Data.BasicInfo.ProjectName;
                    $this.BasicInfo = list;
                    $this.PaymentInfo = res.data.data.PaymentInfo;
                    $this.UserInfo = res.data.data.UserInfo;
                    $this.OtherFee = res.data.data.OtherFee;
                    $this.HotelFee = res.data.data.HotelFee;
                    $this.Allowance = res.data.data.Allowance;
                    $this.TrafficFee = res.data.data.TrafficFee;
                    $this.AuditHistory = res.data.data.AuditHistory;
                    $this.fileRepertories = res.data.data.fileRepertories;
                    $this.LongApplyFor =
                        res.data.data.LongApplyFor == true ? "1" : "2";
                })
                .catch(function(res) {
                    $this.$router.push({ path: "*" });
                });
        }
    },
    created() {
        this.getDetail();
    },
    components: {}
};
</script>
<style>

</style>





// WEBPACK FOOTER //
// src/components/basicInformation2.vue